import React, { useEffect, useMemo, useState } from "react";
import { Alert, Button, List, ListItem, ListItemText } from "@mui/material";
import { useAppSelector } from "../../store/hooks";
import { useDispatch } from "react-redux";
import Timeline, { timelineClasses } from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineOppositeContent, {
  timelineOppositeContentClasses,
} from "@mui/lab/TimelineOppositeContent";
import TimelineDot from "@mui/lab/TimelineDot";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import LaptopMacIcon from "@mui/icons-material/LaptopMac";
import HotelIcon from "@mui/icons-material/Hotel";
import RepeatIcon from "@mui/icons-material/Repeat";
import Typography from "@mui/material/Typography";
import { useDidMountEffect } from "../../utils";
import { UpdateTimeExpenseEntryMutation } from "../../modules/Timer/mutations/UpdateTimeExpenseEntryMutation";
import { timerActions } from "../../store/timerSlice";
import { Communication, PositionEnum } from "../../modules/Timer/types";
import { sendMail } from "../../commands/sendMail";
import UpdateTimeEntry from "../../modules/Timer/UpdateTimeEntry";
import { GetCommunicationMutation } from "../../modules/Timer/mutations/GetCommunicationMutation";

import { LoadingButton } from "@mui/lab";
import { GetSingleTimeExpenseEntryMutation } from "../../modules/Timer/mutations/GetSingleTimeExpenseEntryMutation";
import { useEmail } from "../../core/MailLoader";
import useAlert from "../../core/useAlert";
import { TimeExpenseEntry } from "../../modules/Timer/types-time-entry";

const ComposeMailComponent: React.FC = () => {
  const dispatch = useDispatch();
  const showAlert = useAlert()
  const { mailId, mailTo, mailSubject } = useEmail();
  const steps = useAppSelector((state) => state.timer.steps);
  const { timer, currentTimer, communication, timeExpenseEntry, sendMailLoading } = useAppSelector((state) => state.timer);
  const [open, setOpen] = React.useState(false);
  const [communicationLoading, setCommunicationLoading] = React.useState(true);
  const refetchCommunication = () => {

    dispatch(
      GetCommunicationMutation([mailId], {
        onSuccess: (response: any) => {
          dispatch(
            timerActions.getSteps({
              step: {
                stepId: PositionEnum.CommunicationCreate,
                title: "Communication Log Created",
                subTitle: "Email log created for the matter",
                component: (callback) => (
                  <LoadingButton loading={sendMailLoading} size="small" variant="contained" color={"primary"} onClick={callback}>
                    Send Mail
                  </LoadingButton>
                ),
                data: { resourceType: 3, resourceId: response?.id!, matterId: response?.matterId },
              },
              position: PositionEnum.CommunicationCreate,
            })
          );
        },
        onLoading: setCommunicationLoading,
        onError: (error) => showAlert(error, {
          variant: 'warning'
        })
      })
    )
  }
  useDidMountEffect(() => {
    const position = steps.position;
    dispatch(
      GetSingleTimeExpenseEntryMutation(currentTimer?.id!, {

      })
    );
    if (position === PositionEnum.TimeEntryCreate) {
      refetchCommunication()
    }
  }, [steps]);

  const handleSave = (communication?: Communication, matterId?: string) => {
    const data = {
      ...timeExpenseEntry,
      resourceType: 3,
      resourceId: communication?.id!,
      matterId: matterId!,
      description: mailSubject
    }
    dispatch(
      UpdateTimeExpenseEntryMutation(
        mailId,
        data,
        {
          onSuccess: (response) => {
            handleOnClose()
          },
          onLoading: (loading) => timerActions.getSendMailLoading(loading),
          onError: (error) => showAlert(error, { variant: "error" })
        }
      )
    );
    refetchCommunication()
  };
  const handleOnClose = () => {
    setOpen(false);
  };
  const timeEntryAction = useMemo(() => {
    if (!timer?.isTimerRunning && open) {
      return (
        <UpdateTimeEntry
          onSave={handleSave}
          onClose={handleOnClose}
          timeEntryId={timer?.id as string}
        />
      );
    }
    return null;
  }, [timer?.id, open]);

  return (
    <List>
      <ListItem dense divider>
        <ListItemText
          primary="Primary Client"
          secondary={
            <List dense>
              <ListItem dense>
                <ListItemText secondary={mailTo?.[0] ?? "No Receipients"} />
              </ListItem>
            </List>
          }
        />
      </ListItem>
      {(steps.steps && (
        <Timeline
          sx={{
            [`& .${timelineItemClasses.root}:before`]: {
              display: "none",
            },
          }}
        >
          {steps.steps?.map((step) => (
            <TimelineItem key={step.stepId}>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <ListItemText primary={step.title} secondary={step.subTitle} />
                {step?.component &&
                  !currentTimer?.isTimerRunning &&
                  (() => {
                    switch (step.stepId) {
                      case PositionEnum.TimeEntryCreate:
                        {
                          if (communicationLoading || !Object?.entries(communication ?? {}).length) {
                            return step?.component(() => {
                              setOpen(true);
                            });
                          }
                        }
                        return null;
                      case PositionEnum.CommunicationCreate: {
                        timerActions.getSendMailLoading(true)
                        return step.component(() => {
                          if (!mailTo.length) {
                            showAlert("This message must have at least one recipient", { variant: 'error' })
                            return
                          }
                          if (!mailSubject) {
                            showAlert("There is No subject in this message", { variant: 'error' })
                            return
                          }
                          sendMail()
                        });
                      }
                      default:
                        return <span>None</span>;
                    }
                  })()}
              </TimelineContent>
            </TimelineItem>
          ))}
        </Timeline>
      )) ||
        null}
      {timeEntryAction}
    </List>
  );
};

export default ComposeMailComponent;
